import React from 'react';
import { observer } from 'mobx-react-lite';
import { Box, Typography, Paper, Grid, Card } from '@mui/material';
import { useStore } from '../stores';
import DashboardLayout from '../components/layout/DashboardLayout/DashboardLayout';
import PersonalInfoForm from '../components/forms/PersonalInfoForm';
import ProfilePhoto from '../components/common/ProfilePhoto';

const Profile: React.FC = () => {
    const { authStore } = useStore();

    const handlePhotoChange = (file: File) => {
        console.log('Nueva foto seleccionada:', file.name);
    };

    const handlePhotoDelete = () => {
        console.log('Foto de perfil eliminada');
    };

    return (
        <DashboardLayout>
            <Box>
                <Typography variant="h4" sx={{ mb: 1 }}>
                    Perfil
                </Typography>
                <Grid container spacing={3}>
                    <Grid size={{ xs: 12, md: 6, lg: 7, xl: 7 }}>
                        <PersonalInfoForm />
                    </Grid>
                    <Grid size={{ xs: 12, md: 6, lg: 5, xl: 5 }}>
                        <ProfilePhoto
                            initialName="John Doe"
                            initialPhotoUrl="https://ejemplo.com/foto-perfil.jpg"
                            onPhotoChange={handlePhotoChange}
                            onPhotoDelete={handlePhotoDelete}
                        />
                    </Grid>
                </Grid>
            </Box>
        </DashboardLayout >
    );
};

export default observer(Profile);